<ion-chip
  mode="ios"
  color="transparent"
  [outline]="false"
  class="getm-coins-badge"
  [class.getm-coins-badge--small]="size === 'small'"
>
  <ng-container *ngIf="icon && icon.length > 0">
    <ion-icon [name]="icon" [color]="iconColor"></ion-icon>
  </ng-container>

  <ng-container *ngIf="text && text.length > 0">
    <ion-label [color]="textColor" [innerHTML]="text | htmlSeguro"> </ion-label>
  </ng-container>
</ion-chip>
